import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Menu,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  makeStyles,
  Paper,
  Box,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import AppBarModal from "../general/AppBarModal";
import TareasTerminadas from "../general/TareasTerminadas";
import emma_w from "./../../global/imagenes/emma_w.png";
import { BtnForm } from "../general/BotonesAccion";
import {
  crear_form_data,
  formulario,
  mostrarError,
  obtenerMisDatos,
  obtenerValores,
  obtenerValoresFiltros,
} from "../../global/js/funciones";
import EnviarMultiplesArchivos from "../general/EnviarMultiplesArchivos";
import { PREGUNTA_PLAN_REVISION_TUTOR, REQUISITOS_GRADOS } from "./helper";
import { green, red } from "@material-ui/core/colors";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DeleteIcon from '@material-ui/icons/Delete'

// const requisitosIniciales = [
//   { codigo: "req_plan_trabajo", nombre: "Archivo del Plan de Trabajo" },
//   { codigo: "otros_docs", nombre: "Otros documentos relevantes" }
// ];

const useStyles = makeStyles((theme) => ({
  paper: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
  },
  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  left: {
    display: "flex",
    alignItems: "center",
    minWidth: 0,
    flex: 1,
  },

  statusPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(1),
    backgroundColor: "#b9dfc4bd",
    color: "#000000",
    borderRadius: 500,
    padding: theme.spacing(0.5, 1.25),
    marginTop: theme.spacing(1),
  },

  dot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    marginRight: theme.spacing(1.5),
    flexShrink: 0,
  },
  titles: {
    overflow: "hidden",
  },
  title: {
    fontWeight: 600,
    margin: 0,
  },
  subtitle: {
    color: theme.palette.text.secondary,
  },
  actions: {
    display: "flex",
    alignItems: "center",
    // separador entre acciones
    "& > *:not(:first-child)": {
      marginLeft: theme.spacing(1),
    },
  },
  caption: {
    marginTop: theme.spacing(1),
    color: red[700],
  },
  // opcional: evita mayúsculas forzadas en el botón
  btnText: {
    textTransform: "none",
  },
  iconLeft: {
    marginRight: theme.spacing(1),
  },
}));

const ModalPlanTrabajo = ({
  modalPlanTrabajo,
  showModalPlanTrabajo,
  actualizarMensaje,
  solicitud,
  onPlanTrabajoGuardado
}) => {
  console.log("solicitud: ", solicitud);
  const close = () => showModalPlanTrabajo(false);
  const [cargando_titulo, setCargandoTitulo] = useState("Cargando información...");
  const [cargando, setCargando] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [seleccion, setSeleccion] = useState("integrantes");
  const steps = [
    "Datos generales",
    "Estructura Plan de Trabajo",
    "Evidencias",
    "Validación Tutor",
    "Observaciones",
  ];
  const [solicitante, setSolicitante] = useState({});
  const [requisitos, setRequisitos] = useState([]);
  const [adjuntosOpcionales, setAdjuntosOpcionales] = useState(false);

  const [form, setForm] = useState({
    semestre: null,
    tituloTentativo: "",
    objetivoGeneral: "",
    plan_revisado: "",
    fechaValidacionTutor: null,
    observacion_estu: ""
  });
  const [showMultipleModal, setShowMultipleModal] = useState(false);
  const [archivos, setArchivos] = useState([]);
  const [archivosMultiples, setArchivosMultiples] = useState([]);
  const [revisionTutor, setRevisionTutor] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setCargando(true);
      setRevisionTutor(await obtenerValores(PREGUNTA_PLAN_REVISION_TUTOR));
      setRequisitos(
        await obtenerValoresFiltros([
          { llave: "generica", valor: REQUISITOS_GRADOS },
          { llave: "estado", valor: 1 },
          { llave: "valore", valor: 3 },
        ])
      );
      const datos_sesion = await obtenerMisDatos();
      setSolicitante({
        id: datos_sesion.persona.id,
        nombre: `${datos_sesion.persona.primer_nombre} ${datos_sesion.persona.primer_apellido} ${datos_sesion.persona.segundo_apellido}`,
        identificacion: datos_sesion.persona.identificacion,
        primer_nombre: datos_sesion.persona.primer_nombre,
        primer_apellido: datos_sesion.persona.primer_apellido,
        segundo_nombre: "",
        segundo_apellido: datos_sesion.persona.segundo_apellido,
      });
      setCargando(false);
    };
    fetchData();
  }, []);

  const handleStep = (next) => {
    if (next) {
      if (!validateStep(activeStep)) return;
      setActiveStep((prev) => prev + 1);
    } else {
      setActiveStep((prev) => prev - 1);
    }
  };

  const isEmpty = (v) =>
    v === undefined || v === null || String(v).trim() === "";

  const validateStep = (stepIdx) => {
    console.log("stepIdx: ", stepIdx);
    if (stepIdx === 0) {
      if (isEmpty(form.semestre)) {
        actualizarMensaje({
          titulo: "Debe diligenciar el semestre",
          tipo: "info",
          mostrar: true,
          tiempo: 2000,
        });
        return false;
      }
    }

    if (stepIdx === 1) {
      if (isEmpty(form.tituloTentativo) || isEmpty(form.objetivoGeneral)) {
        actualizarMensaje({
          titulo: "Debe diligenciar los campos obligatorios",
          tipo: "info",
          mostrar: true,
          tiempo: 2000,
        });
        return false;
      }
    }

    if (stepIdx === 2) {
      if (archivos.length === 0) {
        actualizarMensaje({
          titulo: "Debe cargar el archivo del Plan de Trabajo para continuar",
          tipo: "info",
          mostrar: true,
          tiempo: 2000,
        });
        return false;
      }
    }

    return true;
  };

  const submit = () => {
    const allFiles = [
      ...archivos,
      ...archivosMultiples
    ].filter(it => it && it.archivo instanceof File);

    // Preparar payload del form
    const data = {
      grado: solicitud?.id,
      tutorAsignado: solicitud?.tutor_propuesto, 
      semestre: form.semestre,
      tituloTentativo: form.tituloTentativo,
      objetivoGeneral: form.objetivoGeneral,
      plan_revisado: form.plan_revisado,
      observacion_estu: form.observacion_estu,
    };
    setCargando(true);
    guardarSolicitud(data, allFiles, () => setCargando(false));
  }

  const handleChange = (e, altValue) => {
    if (e && e.target) {
      const { name, value } = e.target;
      setForm((prev) => ({ ...prev, [name]: value }));
      return;
    }

    const fecha = e || null;
    setForm((prev) => ({ ...prev, fechaValidacionTutor: fecha }));
  };

  const guardarSolicitud = async (data, archivosAdjuntos = [], callback) => {
    let formdata = await crear_form_data(data);

    formdata.append("total", String(archivosAdjuntos.length));
    archivosAdjuntos.forEach(( item, idx ) => {
        formdata.append(`archivo${idx}`, item.archivo, item.archivo.name);
        formdata.append(`codigo${idx}`, item.codigo);
    });
    formulario(
      `api/v1.0/grados/planTrabajo/crear`,
      formdata,
      "post",
      (err, estado, resp) => {
        let titulo = "Ha ocurrido un error, contacte con el administrador.",
          tipo = "error";
        console.log("erro: ", err)
        if (err || estado === 500) {
          tipo = "error";
          titulo = resp?.titulo || "Ha ocurrido un error, contacte con el administrador.";
        } else if(estado === 200) {
          tipo = "success";
          titulo = resp.titulo;
          onPlanTrabajoGuardado(resp);
          close();
        } else {
            tipo = "info";
            titulo = resp.titulo ? resp.titulo : mostrarError(resp);
            //onPlanTrabajoGuardado(resp);
            //close();
        }
        callback();
        actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
      }
    );
  };

  return (
    <React.Fragment>
      <Dialog
        open={modalPlanTrabajo}
        onClose={close}
        fullWidth={true}
        fullScreen={
          typeof window !== "undefined" ? window.innerWidth < 600 : false
        }
        maxWidth="md"
        aria-labelledby="plan-trabajo-dialog-title"
      >
        <AppBarModal
          titulo={"Plan de Trabajo"}
          mostrarModal={close}
          titulo_accion={"pendientes"}
        />

        <DialogContent className="scroll">
          {!cargando ? (
            <Grid container>
              <Grid item xs={12} md={12}>
                <Stepper activeStep={activeStep}>
                  {steps.map((label) => (
                    <Step key={label}>
                      <StepLabel>
                        <p>{label}</p>
                      </StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </Grid>
              <Grid item xs={12} md={12}>
                <Menu
                  sele={seleccion}
                  seleccionar={(seleccion) => setSeleccion(seleccion)}
                />
                {(() => {
                  switch (activeStep) {
                    case 0:
                      return (
                        <DatosGenerales
                          solicitante={solicitante}
                          setSolicitante={setSolicitante}
                          solicitud={solicitud}
                          form={form}
                          handleChange={handleChange}
                        />
                      );
                    case 1:
                      return (
                        <EstructuraPlanTrabajo
                          form={form}
                          handleChange={handleChange}
                        />
                      );
                    case 2:
                      return (
                        <Evidencias
                          requisitos={requisitos}
                          submit={submit}
                          setAdjuntosOpcionales={setAdjuntosOpcionales}
                          showMultipleModal={showMultipleModal}
                          setShowMultipleModal={setShowMultipleModal}
                          archivos={archivos}
                          setArchivos={setArchivos}
                          archivosMultiples={archivosMultiples}
                          setArchivosMultiples={setArchivosMultiples}
                        />
                      );
                    case 3:
                      return (
                        <ValidacionTutor
                          revisionTutor={revisionTutor}
                          form={form}
                          handleChange={handleChange}
                        />
                      );
                    case 4:
                      return (
                        <Observaciones
                          form={form}
                          handleChange={handleChange}
                        />
                      );
                    default:
                      return null;
                  }
                })()}
              </Grid>
            </Grid>
          ) : (
            <div>
              <TareasTerminadas
                imagen={emma_w}
                mensaje={cargando_titulo}
                widthImg="7%"
                marginTop="7%"
                cargando={true}
              />
            </div>
          )}
        </DialogContent>
        <DialogActions>
          {!cargando &&
            (activeStep == 0 ? (
              <BtnForm
                texto="SIGUIENTE"
                callback={() => handleStep(true)}
                type="submit"
              />
            ) : activeStep == 4 ? (
              <div>
                <BtnForm texto="ATRAS" callback={() => handleStep(false)} />
                <BtnForm
                  texto="ENVIAR"
                  callback={() => {
                    submit();
                  }}
                />
              </div>
            ) : (
              <div>
                <BtnForm texto="ATRAS" callback={() => handleStep(false)} />
                <BtnForm
                  texto="SIGUIENTE"
                  callback={() => handleStep(true)}
                  type="submit"
                />
              </div>
            ))}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

const DatosGenerales = ({ solicitante, solicitud, form, handleChange }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6} lg={6}>
        <TextField
          type="text"
          id={"nombre"}
          name={"nombre"}
          label={"Nombre"}
          defaultValue={solicitante.nombre}
          fullWidth
          autoComplete="billing address-line1"
          value={solicitante.nombre || ""}
          required
          disabled
        />
      </Grid>
      <Grid item xs={12} md={6} lg={6}>
        <TextField
          type="text"
          id={"identificacion"}
          name={"identificacion"}
          label={"Numero de documento"}
          defaultValue={solicitante.identificacion}
          fullWidth
          autoComplete="billing address-line1"
          value={solicitante.identificacion || ""}
          required
          disabled
        />
      </Grid>
      <Grid item xs={12} md={6} lg={6}>
        <TextField
          type="date"
          id="fecha_registro"
          name="fecha_registro"
          label="Fecha diligenciamiento"
          fullWidth
          value={
            solicitud.fecha_registro
              ? solicitud.fecha_registro.split("T")[0]
              : ""
          }
          InputLabelProps={{ shrink: true }}
          required
          disabled
        />
      </Grid>
      <Grid item xs={12} md={6} lg={6}>
        <TextField
          type="text"
          id={"tutor"}
          name={"tutor"}
          label={"Tutor asignado"}
          defaultValue={solicitud.tutor_propuesto}
          fullWidth
          value={solicitud.tutor_propuesto || ""}
          required
          disabled
        />
      </Grid>
      <Grid item xs={12} md={6} lg={6}>
        <TextField
          type="number"
          id={"semestre"}
          name={"semestre"}
          label={"Semestre"}
          value={form.semestre}
          onChange={handleChange}
          fullWidth
          required
        />
      </Grid>
    </Grid>
  );
};

const EstructuraPlanTrabajo = ({ form, handleChange }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6} lg={6}>
        <TextField
          type="text"
          id={"tituloTentativo"}
          name={"tituloTentativo"}
          label={"Título tentativo del proyecto de tesis"}
          value={form.tituloTentativo}
          onChange={handleChange}
          fullWidth
          autoComplete="billing address-line1"
          required
        />
      </Grid>
      <Grid item xs={12} md={6} lg={6}>
        <TextField
          type="text"
          id={"objetivoGeneral"}
          name={"objetivoGeneral"}
          label={"Objetivo general"}
          value={form.objetivoGeneral}
          onChange={handleChange}
          fullWidth
          autoComplete="billing address-line1"
          required
        />
      </Grid>
      {/* <Grid item xs={12} md={6} lg={6}>
                <TextField type="text" id={'tutor'} name={'tutor'} label={'Cronograma estimado de trabajo'} fullWidth required />
            </Grid> */}
    </Grid>
  );
};

const Evidencias = ({
  requisitos,
  submit,
  showMultipleModal,
  setShowMultipleModal,
  archivos,
  setArchivos,
  archivosMultiples,
  setArchivosMultiples,
}) => {
  const classes = useStyles();
  const hayArchivo = Array.isArray(archivos) && archivos.length > 0;
  const nombreArchivo = hayArchivo ? archivos[0]?.archivo?.name : "";

  const handleSingleFileUpload = (file) => {
    if (file) {
      const nuevoArchivo = { codigo: "req_plan_trabajo", archivo: file };
      const nuevosArchivos = [nuevoArchivo];
      setArchivos(nuevosArchivos);
    }
  };

  const submitMultipleFiles = (archivosSubidos, done) => {
    if (!archivosSubidos || archivosSubidos.length === 0) return;

    // si vienen como File directo, normaliza
    const nuevos = archivosSubidos.map((item) =>
      item instanceof File ? { codigo: "otros_docs_re", archivo: item } : item
    );

    setArchivosMultiples((prev) => [...prev, ...nuevos]);

    setShowMultipleModal(false);
  };

  const eliminarArchivo = (index, tipo) => {
    if (tipo === "simple") {
      setArchivos([]);
    } else {
      const nuevosArchivos = [...archivosMultiples];
      nuevosArchivos.splice(index, 1);
      setArchivosMultiples(nuevosArchivos);
    }
  };

  const todosLosArchivos = [...archivos, ...archivosMultiples];

  return (
    <Grid container spacing={3}>
      {/* Sección para Archivo del Plan de Trabajo */}
      <Grid item xs={12}>
        <Paper className={classes.paper} elevation={0}>
          <div className={classes.row}>
            <div className={classes.left}>
              <span
                className={classes.dot}
                style={{ backgroundColor: hayArchivo ? green[600] : red[500] }}
              />
              <Box className={classes.titles}>
                <Typography
                  variant="subtitle1"
                  className={classes.title}
                  noWrap
                >
                  Archivo del Plan de Trabajo
                </Typography>
                <Typography variant="body2" className={classes.subtitle} noWrap>
                  Documento principal requerido
                </Typography>
              </Box>
            </div>

            {/* Acciones */}
            <div className={classes.actions}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                component="label"
                classes={{ label: classes.btnText }}
              >
                <CloudUploadIcon
                  fontSize="small"
                  className={classes.iconLeft}
                />
                {hayArchivo ? "Cambiar" : "Cargar"}
                <input
                  type="file"
                  hidden
                  onChange={(e) => {
                    const file = e.target.files && e.target.files[0];
                    if (file) handleSingleFileUpload(file);
                    // opcional: reset para permitir subir el mismo archivo de nuevo
                    e.target.value = null;
                  }}
                />
              </Button>

              {hayArchivo && (
                <Tooltip title="Eliminar archivo">
                  <IconButton
                    color="secondary"
                    size="small"
                    onClick={() => eliminarArchivo(0, "simple")}
                    aria-label="Eliminar archivo"
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          </div>

          {/* Estado de carga */}
          
          {hayArchivo && (
            <span className={classes.statusPill}>
                <CheckCircleIcon style={{ color: green[700] }} fontSize="small" />
                <Typography variant="caption" style={{ fontWeight: 600 }}>
                    Archivo cargado: {nombreArchivo}
                </Typography>
          </span>
          )}
        </Paper>
      </Grid>

      {/* Sección para Otros Documentos Relevantes */}
      <Grid item xs={12}>
        <Paper className={classes.paper} elevation={0}>
          <div className={classes.row}>
            {/* Lado izquierdo: dot + títulos */}
            <div className={classes.left}>
              <span
                className={classes.dot}
                style={{
                  backgroundColor:
                    archivosMultiples.length > 0 ? green[600] : red[500],
                }}
              />
              <Box className={classes.titles}>
                <Typography
                  variant="subtitle1"
                  className={classes.title}
                  noWrap
                >
                  Otros Documentos Relevantes
                </Typography>
                <Typography variant="body2" className={classes.subtitle} noWrap>
                  Documentos adicionales (opcional)
                </Typography>
                 {archivosMultiples.length > 0 && (
                <Typography variant="caption" className={classes.subtitle}>
                  Cargados: {archivosMultiples.length} archivo
                  {archivosMultiples.length !== 1 ? "s" : ""}
                </Typography>
                )}
              </Box>
            </div>

            {/* Acciones */}
            <div className={classes.actions}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={() => setShowMultipleModal(true)}
                classes={{ label: classes.btnText }}
              >
                <CloudUploadIcon
                  fontSize="small"
                  className={classes.iconLeft}
                />
                {archivosMultiples.length > 0 ? "Gestionar" : "Cargar"}
              </Button>
            </div>
          </div>

          {/* Lista de archivos cargados */}
          {archivosMultiples.length > 0 && (
            <Box mt={2}>
              {archivosMultiples.map((archivo, index) => (
                <Box
                  key={index}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  py={1}
                  borderBottom={
                    index < archivosMultiples.length - 1
                      ? "1px solid #eee"
                      : "none"
                  }
                >
                   <span className={classes.statusPill}>
                      <CheckCircleIcon style={{ color: green[700] }} fontSize="small" />
                      <Typography variant="caption" style={{ fontWeight: 600 }}>
                          {archivo.archivo.name}
                      </Typography>
                  </span>
                  {/* <Typography variant="body2" style={{ color: red[700] }}>
                    • {archivo.archivo.name}
                  </Typography> */}
                  <Tooltip title="Eliminar archivo">
                    <IconButton
                      color="secondary"
                      size="small"
                      onClick={() => eliminarArchivo(index, "multiple")}
                      aria-label="Eliminar archivo"
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              ))}
            </Box>
          )}
        </Paper>
      </Grid>

      {/* Modal para múltiples archivos */}
      <Dialog
        open={showMultipleModal}
        onClose={() => setShowMultipleModal(false)}
        maxWidth="md"
        fullWidth
      >
        <AppBarModal
          titulo="Cargar Otros Documentos Relevantes"
          mostrarModal={() => setShowMultipleModal(false)}
          titulo_accion="Cerrar"
        />
        <DialogContent>
          <Typography variant="body1" gutterBottom>
            Puede subir los archivos adicionales que considere relevantes para
            su plan de trabajo.
          </Typography>
          {/* <Typography variant="body2" color="textSecondary" gutterBottom style={{ marginBottom: '20px' }}>
            Formatos permitidos: PDF, DOC, DOCX
          </Typography> */}

          <EnviarMultiplesArchivos
            modalMulArchivos={false}
            enModal={false}
            lista={requisitos.filter(
              (req) => req.codigo !== "req_plan_tdrabajo"
            )}
            enLista={false}
            enviarArchivos={submitMultipleFiles}
            titulo="Documentos Relevantes"
            mensaje="Arrastre y suelte los archivos aquí o haga clic para seleccionar"
            mostrarRender={true}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowMultipleModal(false)} color="primary">
            Cerrar
          </Button>
          <Button
            onClick={() =>
              document.getElementById("enviar_form_multi_archivo").click()
            }
            color="primary"
            variant="contained"
          >
            Guardar Archivos
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

const ValidacionTutor = ({ revisionTutor, form, handleChange }) => (
  <Grid container spacing={3}>
    {console.log("form: ", form)}
    <Grid item xs={12} md={6} lg={6}>
      <FormControl className="form-control">
        <InputLabel>
          ¿El plan fue revisado y aprobado por el tutor? *
        </InputLabel>
        <Select
          name="plan_revisado"
          value={form.plan_revisado}
          onChange={handleChange}
        >
          {revisionTutor.map((op) => (
            <MenuItem key={op.id} value={op.id}>
              {" "}
              {op.nombre}{" "}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
    {/* <Grid item xs={12} md={6} lg={6}>
      <FormControl className="form-control">
        <MuiPickersUtilsProvider locale={es} utils={DateFnsUtils}>
          <Grid container>
            <KeyboardDatePicker
              required={true}
              style={{ marginTop: 3, width: "100%" }}
              margin="normal"
              label="Fecha de validación del plan por el tutor"
              format="yyyy/MM/dd"
              value={form.fechaValidacionTutor}
              onChange={handleChange}
              openTo="year"
              KeyboardButtonProps={{
                "aria-label": "Cambiar fecha",
              }}
              maxDate={Date("yyyy/MM/dd")}
              invalidDateMessage="Formato Invalido"
              cancelLabel="Cancelar"
              okLabel="Aceptar"
              todayLabel="Hoy"
              clearLabel="Limpiar"
              dayText="Día"
              monthText="Mes"
              yearText="Año"
              formatDay="EE"
              formatMonth="MMMM"
              formatYear="yyyy"
              InputProps={{
                readOnly: true,
                onClick: () =>
                  document
                    .querySelector('button[aria-label="Cambiar fecha"]')
                    .click(),
              }}
            />
          </Grid>
        </MuiPickersUtilsProvider>
      </FormControl>
    </Grid> */}
  </Grid>
);

const Observaciones = ({handleChange, form }) => (
  <Grid container spacing={3}>
    <Grid item xs={12} md={6} lg={6}>
      <TextField
        type="text"
        id={"observacion_estu"}
        name={"observacion_estu"}
        label={"Observaciones del estudiante"}
        value={form.observacion_estu}
        onChange={handleChange}
        fullWidth
        autoComplete="billing address-line1"
      ></TextField>
    </Grid>
  </Grid>
);

ModalPlanTrabajo.defaultProps = { modalPlanTrabajo: false };
ModalPlanTrabajo.propTypes = {
  modalPlanTrabajo: PropTypes.bool,
  showModalPlanTrabajo: PropTypes.func.isRequired,
};

export default ModalPlanTrabajo;
